const composeRefs = (...args) => {
	return ref => {
		args.forEach(arg => {
			if (!arg) {
				return;
			}

			if (typeof arg === "function") {
				arg(ref);
				return;
			}

			// eslint-disable-next-line no-param-reassign
			arg.current = ref;
		});
	};
};

export default composeRefs;
